export default __webpack_public_path__ + "static/media/bank-card-icon.38c04cd7.svg";